
(function($, B) {
    'use strict';

    var bmatch =  function(search, type) {
        var match = null;
        if (typeof search === 'string' && search !== '') {
            switch (type) {
                case 'sufix':
                    break;
                case 'contains':
                    match = new RegExp('(' + search + ')', 'g');
                    break;
                default:
                    match = new RegExp('\\b(' + search + '\\S*)', 'g');
            }
        }
        return match;
    };

    $.fn.getChildsHeight = function(){
        var childsHeight=0,
            $this = $(this);
        $this.children().each(function(){
            childsHeight+=$(this).outerHeight(true);
        });
        return childsHeight;
    };

    $.fn.removeClassSearch = function(search, type) {
        var classMatch = bmatch(search, type);
        if (classMatch) {
            this.removeClass(function() {
                return (this.className.match(classMatch) || []).join(' ');
            });
        }
        return this;
    };        

    $.fn.changeIcon=function(icon){//font canvas
        if(typeof icon === 'string' && icon!==''){
            var iClass= icon.indexOf('icon-')< 0 ? 'icon-'+icon : icon,
                $i=this.hasClass('icon') ? this : this.find('.icon');
                $i.removeClassSearch('icon-').addClass(iClass);
        }
        return this;
    };

    $.extend(true, B, {
        web:{
            onReady:{
    
            },
            onScroll:{

            },
            onResize:{

            },
            toInit:{
            }, 
            selectors:{
                header: '#header-b',
                primaryMenu: 'nav.primary-menu'
            },
            widgets:{    
            },
            $elements:{
            },
            data:{
            },
            getElements:function(selectors, target, $container){
                target = target || {};
                for(var k in selectors){
                    target[k]=$container ? $container.find(selectors[k]) : ($(selectors[k]));
                    target[k] = target[k].length > 0 ? target[k] : null;
                }
            },
            init:function(){
                this.getElements(this.selectors, this.$elements);
                for(var k in this.toInit){
                    if(this.toInit[k]){
                        this.widgets[k].init();
                    }
                }
            },
            documentReady:function(){
                B.runFunctions(B.web.onReady);
            },
            windowScroll:function(){
                B.runFunctions(B.web.onScroll);
            },
            windowResize:function(){
                B.runFunctions(B.web.onResize);
            }
        }
    });
        
    $(document).ready(function() { 
        B.web.init();
        B.web.documentReady();
        $(window).on('scroll', B.web.windowScroll);
        $(window).on('resize', B.web.windowResize);
        // $(window).on('scroll', function(){
        //     B.web.windowScroll();
        // });
        // $(window).on('resize', function(){
        //     B.web.windowResize();
        // });
    });




})(jQuery, Bajt);
